import { MDBCol, MDBContainer, MDBFooter, MDBIcon, MDBRow } from "mdb-react-ui-kit"
import { Link } from 'react-router'
import logo from '../assets/logo.jpeg'
import partner1_logo from '../assets/partner1.jpeg'
import partner2_logo from '../assets/partner2.jpeg'
import partner3_logo from '../assets/partner3.jpeg'


export function Footer() {

    // date
    const date = new Date()

    // year
    const year = date.getFullYear()


    return (
        <>
            <MDBFooter bgColor='light' className='border border-0 border-danger text-center text-lg-start text-muted'>
                <MDBContainer className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
                    <div className='me-5 d-none d-lg-block'>
                        Connect with us
                    </div>

                    <div>
                        <a href='https://www.facebook.com/share/16jbZWVmyT/' className='me-4 text-reset'>
                            <MDBIcon fab icon="facebook-f" />
                        </a>
                        {/* <a href='' className='me-4 text-reset'>
                            <MDBIcon fab icon="twitter" />
                        </a>
                        <a href='' className='me-4 text-reset'>
                            <MDBIcon fab icon="google" />
                        </a>
                        <a href='' className='me-4 text-reset'>
                            <MDBIcon fab icon="instagram" />
                        </a>
                        <a href='' className='me-4 text-reset'>
                            <MDBIcon fab icon="linkedin" />
                        </a>
                        <a href='' className='me-4 text-reset'>
                            <MDBIcon fab icon="github" />
                        </a> */}
                    </div>
                </MDBContainer>

                    <MDBContainer className='border border-0 border-danger text-center text-md-start mt-5'>
                        <MDBRow around className='mt-3'>
                            <MDBCol md="3" lg="4" xl="3" className='border border-0 border-danger  mb-4'>
                                <h6 className='text-uppercase fw-bold mb-4'>
                                    <Link to={''}>
                                        <img style={{ height: '100px' }} src={logo} alt="logo" />
                                    </Link>
                                </h6>
                                <p>
                                A research and development organization that promotes neglected and
                                underutilized crop species.
                                </p>
                            </MDBCol>

                            <MDBCol md="3" lg="2" xl="2" className='border border-0 border-danger mb-4'>
                                <h6 className='text-uppercase fw-bold mb-4'>Links</h6>
                                <p>
                                    <a href='#' className='text-reset'>
                                        <Link to={''} className={'text-muted'}>Home</Link>
                                    </a>
                                </p>
                                <p>
                                    <a href='#' className='text-reset'>
                                        <Link to={'about_us'} className={'text-muted'}>About Us</Link>
                                    </a>
                                </p>
                                <p>
                                    <a href='#' className='text-reset'>
                                        <Link to={'contact_us'} className={'text-muted'}>Contact Us</Link>
                                    </a>
                                </p>
                                <p>
                                    <a href='#' className='text-reset'>
                                        <Link to={'meet_our_team'} className={'text-muted'}>Meet Our Team</Link>
                                    </a>
                                </p>
                            </MDBCol>

                            <MDBCol md="3" lg="2" xl="2" className='border border-0 border-danger mb-4'>
                                <h6 className='text-uppercase fw-bold mb-4'>Our Partners</h6>
                                <p>
                                    <a href='https://alliancebioversityciat.org/stories/farmers-guardians-conserving-ghanas-minor-crops' className='text-reset'>
                                        <img style={{height:'100px', width:'180px'}} src={partner1_logo} alt="partner1 logo" />
                                    </a>
                                </p>
                                <p>
                                    <a href='#' className='text-reset'>
                                        <img style={{height:'100px'}} src={partner2_logo} alt="partner2 logo" />
                                    </a>
                                </p>
                                <p>
                                    <a href='#' className='text-reset'>
                                        <img style={{height:'100px'}} src={partner3_logo} alt="partner3 logo" />
                                    </a>
                                </p>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>

                <MDBRow center className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
                    © {year} All right reserved
                </MDBRow>
            </MDBFooter>
        </>
    )
}